import React, { useState, useEffect, useContext, useRef, memo } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import Loader from "../../Setup/views/Loader";
import useFormSubmission from '../../Auth/Controller/AuthController';
import ModuleService from '../../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../../Layout/SidebarContext';
import BASE_URL from "../../../config/config";
// Import FullCalendar and plugins
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'; // For drag and drop
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import JobService from "../../Jobs/Controller/JobController";
import TeamService from "../../Setup/controller/TeamController/TeamController";
import UserService from "../../Setup/controller/UserController/UserController";
import { CreateEngineer } from "../../Jobs/Controller/CreateJobEngineerController";
import { handleChange, handleUpdate } from "../../Jobs/Controller/UpdateEngineerTimeController";
import Common from '../../Common/Common';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ProjectService from "../../Setup/controller/ProjectMemberController/ProjectMemberController";
import DiariesLabelService from "../../Setup/controller/DiariesLabelController/Controller/DiariesController";
import Swal from 'sweetalert2';
/// Shahid---------------------
import HelpSite from "../../Common/HelpLink";
import JobDetailModal from "../../Jobs/View/JobDetail";
import OppurtunityDetailModal from "../../Oppurtunity/Views/OppurtunityDetail";
import LeadDetailModal from "../../Lead/Views/LeadDetail";
import CreateCustomerModal from "../../Customer/View/CreateCustomer";
import SupplierDetailModal from "../../Supplier/View/SupplierDetail";
import MultiSelectDropdown from "./MultiSelectDropdown";
import CustomerHistoryService from "../../Customer/Controller/CustomerHistoryController";
import Cookies from 'js-cookie';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";

const ExternalEvent = memo(({ event }) => {
    let elRef = useRef(null);

    useEffect(() => {

        let draggable = new Draggable(elRef.current, {
            eventData: function () {
                return { ...event, create: true };
            }
        });

        // a cleanup function
        return () => draggable.destroy();
    });

    return (
        <div
            ref={elRef}
            className="fc-event fc-h-event mb-1 fc-daygrid-event fc-daygrid-block-event"
            id={event.id}
            data-color={event.color}
            title={event.title}
            style={{
                backgroundColor: event.color,
                borderColor: event.color,
                cursor: "pointer"
            }}
        >
            <div className="fc-event-main">
                <div>
                    <strong style={{ "color": "#ffffff" }}>{event.title}</strong>
                </div>
            </div>
        </div>
    );
});


/// Shahid---------------------end --
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Diaries: 11
};

function DiariesView() {


    const { theme, toggleTheme } = useContext(ThemeContext);
    const navigate = useNavigate();
    const { updateSidebarModules } = useContext(SidebarContext);
    const RoleName = localStorage.getItem('RoleName');

    const UserID = localStorage.getItem('UserID');
    const HelpLink = localStorage.getItem('HelpLink');
    const [formData, setFormData] = useState({});
    const location = useLocation();
    const url = new URL(window.location.origin + location.pathname);
    const pathname = url.pathname;
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const IsAdminLogin = localStorage.getItem('IsAdminLogin');
    const handleSubmit = useFormSubmission();
    const [errorMessage, setErrorMessage] = useState('');
    const [teams, setTeams] = useState([]);
    const [users, setUsers] = useState([]);
    const [userList, setUserList] = useState([]);
    // State to hold calendar events
    const [events, setEvents] = useState([]);

    // State to control calendar view (Week, Day, Month)
    const [calendarView, setCalendarView] = useState('timeGridWeek'); // Default to weekly view

    // State for slot duration
    const [slotDuration, setSlotDuration] = useState('01:00:00'); // Default to 1 hour
    const [EventType, setEventType] = useState('All');
    const [selectedTeam, setSelectedTeam] = useState(0);
    // State to control sidebar visibility
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('engineers');
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Default to today's date
    const calendarRef = useRef(null);
    const [ProjectList, setProject] = useState([]);
    const [ProjectID, setProjectID] = useState(localStorage.getItem("ProjectID") || ""); // Initial empty state
    const [jobList, setJobData] = useState([]);
    const [filteredJobList, setFilteredJobList] = useState([]); // Filtered job list
    const CompanyID = localStorage.getItem("CompanyID");

    const [selectedJob, setSelectedJob] = useState(null); // or initialize with the default job
    const [selectedUser, setSelectedUser] = useState(null); // or initialize with the default user
    const [selectedProject, setSelectedProject] = useState(''); // or initialize with the default project
    const [Weekened, setWeekened] = useState(true);
    const [loading, setLoading] = useState(true);
    const [timeOption, setTimeOption] = useState('workingHours');
    const [DiariesLabel, setDiariesLabel] = useState('Engineers');
    const [assignedEngineers, setAssignedEngineers] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
    const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
    const [TaskList, setTaskList] = useState([]);
    const [AppointmentList, setAppointmentList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [isJobModalOpen, setIsJobModalOpen] = useState(false);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = useState(false);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false);
    const [LeadID, setLeadID] = useState('0');
    const [OpportunityID, setOpportunityID] = useState('0');
    const [ClientCompanyID, setClientCompanyID] = useState('0');
    const [SupplierID, setSupplierID] = useState('0');
    const [taskID, setTaskID] = useState('0');
    const [assignedModules, setAssignedModules] = useState(new Set());
    /// Shahid---------------------
    const UserLockRelease = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }

            await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };


    const handleEventReceive = async (eventInfo) => {

        const newEvent = {
            id: eventInfo.draggedEl.getAttribute("id"),
            title: eventInfo.draggedEl.getAttribute("title"),
            color: eventInfo.draggedEl.getAttribute("data-color"),
            start: eventInfo.date,
            end: eventInfo.date,
            custom: eventInfo.draggedEl.getAttribute("data-custom")
        };

        const IssueID = selectedJob;
        const UserID = newEvent.id;
        const { start, end } = eventInfo.event;
        const date = new Date(start);
        const padZero = (num) => (num < 10 ? `0${num}` : num);
        const startDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
        date.setHours(date.getHours() + 1);
        const endDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
        const TotalTime = '1.00';
        const TotalTravelTime = '0.00';
        const PayRateID = '1';
        eventInfo.event.setEnd(date);
        const newEngineer = {
            id: eventInfo.draggedEl.getAttribute("id"),
            title: eventInfo.draggedEl.getAttribute("title"),
            color: eventInfo.draggedEl.getAttribute("data-color"),
            start: startDate,
            end: endDate,
        };

        setAssignedEngineers((prevAssigned) => [...prevAssigned, newEngineer]);

        const postData = {
            IssueID,
            UserID,
            startDate,
            endDate,
            TotalTime,
            TotalTravelTime,
            PayRateID,
        };
        const redirectCallback = () => navigate('/');
        //   const Message = await CreateEngineer(postData, redirectCallback);
        //   fetchJobEngineers();

    };

    /// Shahid -------------end----------------///
    useEffect(() => {

        const fetchProject = async () => {
            try {
                const redirectCallback = () => navigate('/');

                const list = await ProjectService.GetProjectMemberByID(redirectCallback);

                const filteredList = list.filter(project => project.ID !== 0); // Remove project with ID 0
                setProject(filteredList[0]);

                if (filteredList.length > 0) {
                    let initialProjectID;

                    // Look for a default project
                    const defaultProjectList = filteredList[0].filter(project => project.IsDefault === "1" || project.IsDefault === 1);
                    if (defaultProjectList.length > 0) {
                        initialProjectID = defaultProjectList[0].ID;
                    } else {
                        // Set to the first project in the filtered list
                        initialProjectID = filteredList[0].ID;
                    }
                    setProjectID(initialProjectID);
                    localStorage.setItem("ProjectID", initialProjectID);
                    await fetchJob(initialProjectID);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchProject();

    }, []);
    useEffect(() => {
        IsModuleAssigned();
        fetchJobEngineers();
        fetchTeams();
        fetchDiariesLabel();
        fetchAllUsers();
        fetchAssignedModules();
        UserLockRelease();
    }, [theme]);
    useEffect(() => {
        const cookieSelected = Cookies.get("SelectedUsers");
        if (cookieSelected) {
            const parsedUsers = JSON.parse(cookieSelected);
            setSelectedUsers(parsedUsers);
            handleUserNameChange(parsedUsers); // 🟢 Trigger event fetch
        } else {
            const loggedInUserID = localStorage.getItem("UserID");
            if (userList.length > 0 && loggedInUserID) {
                const preSelected = userList.find(u => u.UserID.toString() === loggedInUserID.toString());
                if (preSelected) {
                    const fallbackUsers = [preSelected.UserID.toString()];
                    setSelectedUsers(fallbackUsers);
                    handleUserNameChange(fallbackUsers); // 🟢 Trigger event fetch
                }
            }
        }
    }, [userList]);
    useEffect(() => {
        IsModuleAssigned();
        if (teams.length > 0 && selectedTeam === 0) {
            // Set the first team as selected and fetch users for it
            const initialTeamID = teams[0].PK_Team_ID;
            setSelectedTeam(initialTeamID);
            fetchUsers(initialTeamID);
        }
    }, [teams]);
    const fetchTeams = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const teamData = await TeamService.GetAllTeams(redirectCallback);
            setTeams(teamData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchTask = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const taskData = await JobService.TaskForDiaries(redirectCallback);
            setTaskList(taskData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchAppointments = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobService.AppointmentsForDiaries(redirectCallback);
            setAppointmentList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchDiariesLabel = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const ClientID = localStorage.getItem('CompanyID');
            const diaireLabel = await DiariesLabelService.GetDiariesLabel(redirectCallback, ClientID);
            if (diaireLabel.length > 0) {
                setDiariesLabel(diaireLabel[0].DiariesLable);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handleTeamChange = (event) => {
        const { value } = event.target;
        setSelectedTeam(value);
        setSelectedUser(null);
        fetchUsers(value);
    };
    const fetchUsers = async (TeamID) => {
        try {
            const redirectCallback = () => navigate('/');
            const usersData = await UserService.fetchUserByTeam(redirectCallback, TeamID);
            // Creating a new array with different attribute names
            const myusers = usersData.map(user => ({
                title: user.DisplayName,  // Change 'title' to 'name'
                color: user.Color,  // Change 'color' to 'backgroundColor'
                id: user.UserID  // Change 'id' to 'identifier'
            }));
            setUsers(myusers);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const fetchAllUsers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const usersData = await UserService.getAllUsers(redirectCallback);
            setUserList(usersData);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const handleChanges = (event, formData, setFormData) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFieldChange = (event) => {

        handleChanges(event, formData, setFormData);
        if (event.target.name === "ProjectID") {
            setProjectID(event.target.value);
            setSelectedProject(event.target.value);
            setSelectedJob(null);
            fetchJob(event.target.value);
        }
    };
    const fetchJob = async (projectID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const jobsData = await JobService.GetAllJobs(redirectCallback, 0, 0, 0, 0, projectID, 0, "5000", "", "IssueID", "DESC");
            setJobData(jobsData);
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
    };
    const fetchJobEngineers = async () => {
        setLoading(true);
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);
            const filteredEngineers = jobEngineers.filter(engineer => selectedUsers.includes(String(engineer.UserID)));

            //const filteredEngineers = jobEngineers.filter(engineer => engineer.UserID == UserID);
            const formattedEvents = filteredEngineers.map(engineer => ({
                title: engineer.IssueTitle, // Modify as per your data structure
                start: engineer.StartTime ? new Date(engineer.StartTime.replace("Z", "")) : new Date(),  // Ensure the time format is compatible with FullCalendar
                end: engineer.EndTime ? new Date(engineer.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID,
                IsLead: "10",
                eventType: "job",
            }));

            const taskData = await JobService.TaskForDiaries(redirectCallback);
            const filteredTasks = taskData.filter(tas => selectedUsers.includes(String(tas.AssignUserID)));
            //const filteredTasks = taskData.filter(tas => tas.AssignUserID == UserID);
            const taskEvents = filteredTasks.map(task => ({
                title: task.Type, // Modify as per your data structure
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),

                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));

            const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);
            const filteredAppointments = appointmentData.filter(app => selectedUsers.includes(String(app.AssignUserID)));
            //const filteredAppointments = appointmentData.filter(app => app.AssignUserID == UserID);
            const appointmentEvents = filteredAppointments.map(task => ({
                title: task.Type, // Modify as per your data structure
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "opportunity"
            }));

            setEvents([...formattedEvents, ...taskEvents, ...appointmentEvents]);
            // setEvents(formattedEvents); // Update state with the fetched events
        } catch (error) {
            console.error('Error fetching job engineers:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };


    const handleDateClick = async (arg) => {

        /*  if (selectedUser == null) {
              Swal.fire(
                  Error,
                  "Please select Job and User",
                  'error'
              );
              return false;
          }
          const IssueID = selectedJob;
          const UserID = selectedUser;
          const date = new Date(arg.dateStr);
          const padZero = (num) => (num < 10 ? `0${num}` : num);
          const startDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
          date.setHours(date.getHours() + 1);
          const endDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
          const TotalTime = '1.00';
          const TotalTravelTime = '0.00';
          const PayRateID = '1';
  
          const postData = {
              IssueID,
              UserID,
              startDate,
              endDate,
              TotalTime,
              TotalTravelTime,
              PayRateID,
          };
          const redirectCallback = () => navigate('/');
          const Message = await CreateEngineer(postData, redirectCallback);
          fetchJobEngineers(); 
          */
    };
    //const handleEventReceive = (arg) => {

    // };

    // Handle dropdown change for calendar view
    const handleViewChange = (e) => {
        const selectedValue = e.target.value;

        // Handle "Work Week" case by setting view and hiding weekends
        if (selectedValue === 'workWeek') {
            setCalendarView('timeGridWeek'); // Display timeGridWeek for work week
            setWeekened(false); // Hide weekends for work week
        } else {
            setCalendarView(selectedValue); // Update to the selected view
            setWeekened(true); // Show weekends for other views like "Full Week"
        }
    };

    // Handle dropdown change for slot duration
    const handleSlotDurationChange = (e) => {
        setSlotDuration(e.target.value);
    };
    const handleEventType = async (e) => {

        const selectedType = e.target.value; // Get the selected type
        //  setSelectedUsers([]);
        setEventType(selectedType);
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);

        const formattedEvents = jobEngineers
            .filter(engineer => selectedUsers.includes(String(engineer.UserID)))
            .map(engineer => ({
                title: engineer.IssueTitle,
                start: engineer.StartTime ? new Date(engineer.StartTime.replace("Z", "")) : new Date(),
                end: engineer.EndTime ? new Date(engineer.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID,
                IsLead: "10",
                eventType: "job"
            }));

        const taskData = await JobService.TaskForDiaries(redirectCallback);

        const taskEvents = taskData
            .filter(task => selectedUsers.includes(String(task.AssignUserID)))
            .map(task => ({
                title: task.Type,
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));
        const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);
        const appointmentEvents = appointmentData
            .filter(appointment => selectedUsers.includes(String(appointment.AssignUserID)))
            .map(appointment => ({
                title: appointment.Type,
                start: appointment.StartTime ? new Date(appointment.StartTime.replace("Z", "")) : new Date(),
                end: appointment.EndTime ? new Date(appointment.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: appointment.Color,
                description: appointment.vc_Description,
                IssueID: appointment.ID,
                UserID: appointment.LeadID,
                EngineerTimeID: appointment.ID,
                IsLead: appointment.Lead,
                eventType: "opportunity"
            }));

        if (selectedType === "All") {
            // Show all events
            setEvents([...formattedEvents, ...taskEvents, ...appointmentEvents]);
        } else if (selectedType === "Jobs") {
            // Show only job events
            setEvents(formattedEvents);
        } else if (selectedType === "Tasks") {
            // Show only task events
            setEvents(taskEvents);
        } else if (selectedType === "Appointments") {
            // Show only appointment events
            setEvents(appointmentEvents);
        }
    };
    const handleWeekenedChange = (e) => {
        // Convert the string value to true/false
        const isWeekend = e.target.value === "true";
        setWeekened(isWeekend);  // Set the state with the boolean value
    };

    // Compute slotMinTime and slotMaxTime based on the calendarView and slotDuration
    const computeSlotTimes = () => {
        let slotMinTime = '00:00:00';
        let slotMaxTime = '24:00:00';

        if (calendarView === 'timeGridDay' || calendarView === 'timeGridWeek') {
            // Adjust slotMinTime and slotMaxTime to show the full range if necessary
        }

        return { slotMinTime, slotMaxTime };
    };

    const handleEventRender = (info) => {
        const { eventType } = info.event.extendedProps;
        const iconMap = {
            job: '<i class="icofont-briefcase" style={{ marginRight: "5px" }}></i>',
            task: '<i class="icofont-check" style={{ marginRight: "5px" }}></i>',
            opportunity: '<i class="icofont-clock-time" style={{ marginRight: "5px" }}></i>',
        };

        const iconHtml = iconMap[eventType] || '';
        info.el.querySelector('.fc-event-title').innerHTML = `${iconHtml}${info.event.title}`;

        // Add tooltip and background color
        tippy(info.el, {
            content: info.event.extendedProps.description,
            allowHTML: true,
        });
        info.el.style.backgroundColor = info.event.extendedProps.backgroundColor;
    };

    const { slotMinTime, slotMaxTime } = computeSlotTimes();

    // Function to toggle sidebar
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    const handleTabClick = (tab) => {

        setActiveTab(tab);
    };
    const [checkboxState, setCheckboxState] = useState({});
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };
    // JobController.js
    const handleEventDrop = async (eventDropInfo) => {
        const { id } = eventDropInfo.event;
        const { start, end } = eventDropInfo.event;
        const { eventType } = eventDropInfo.event.extendedProps;

        const formatDateWithoutTimezone = (date) => {
            return new Date(date).toISOString().slice(0, 19).replace("T", " "); // Convert to UTC format
        };

        const formatDate = (date) => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
        };



        if (eventType != "task" && eventType != "opportunity") {
            const JobID = eventDropInfo.event._def.extendedProps.IssueID;
            const UserId = eventDropInfo.event._def.extendedProps.UserID;
            const EngineerTimeID = eventDropInfo.event._def.extendedProps.EngineerTimeID;


            const StartTime = formatDate(new Date(start));
            const EndTime = formatDate(new Date(end));

            const { oldEvent } = eventDropInfo;
            const PreviousStartTime = formatDate(new Date(oldEvent.start));
            const PreviousEndTime = formatDate(new Date(oldEvent.end));

            setAssignedEngineers((prevAssigned) =>
                prevAssigned.map((engineer) =>
                    engineer.id === id
                        ? { ...engineer, StartTime, EndTime } // Update start and end times
                        : engineer
                )
            );

            if (id === "" || parseInt(id) === 0) {
                const data = {
                    JobID,
                    UserId,
                    StartTime,
                    EndTime,
                    PreviousStartTime,
                    PreviousEndTime,
                    EngineerTimeID
                };

                try {
                    const message = await handleUpdate(data);
                    // await fetchJobEngineers();

                } catch (error) {
                    eventDropInfo.revert();
                }
            }
        }
        else if (eventType === "task") {
            eventDropInfo.snt_CommunicationType = "2";
            if (eventDropInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "0") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "2") {

                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }



            return false;
        } else if (eventType === "opportunity") {

            eventDropInfo.snt_CommunicationType = "3";
            if (eventDropInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "0") {

                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "2") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }

            return false;
        }
    };
    const handleDateChange = (event) => {

        const date = event.target.value;
        setSelectedDate(date);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(date); // Navigate to selected date
    };
    const handleRowClick = (userId) => {
        setSelectedUser(userId);
    };
    const redirecttoUnAuthorzied = () => {
        navigate('/Unauthorized'); // Redirect to the login page
    };
    const IsModuleAssigned = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            const Modules = await ModuleService.GetModuleByClientID(CompanyID, "11");
            if (Modules.length === 0) {
                Swal.fire(
                    'UnAuthorzied Access!',
                    'Sorry, You are not authorized to access this module.',
                    'warning'
                );
                redirecttoUnAuthorzied();
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handleRowClickIssue = (IssueID) => {
        setSelectedJob(IssueID);
    };
    const handleEventResize = async (eventResizeInfo) => {
        const { id } = eventResizeInfo.event;
        const { sourceId, start, end } = eventResizeInfo.event;
        const { eventType } = eventResizeInfo.event._def.extendedProps;

        const formatDateWithoutTimezone = (date) => {
            return new Date(date).toISOString().slice(0, 19).replace("T", " "); // Convert to UTC format

        };


        if (eventType != "task" && eventType != "opportunity") {
            const JobID = eventResizeInfo.event._def.extendedProps.IssueID;
            const UserId = eventResizeInfo.event._def.extendedProps.UserID;
            const EngineerTimeID = eventResizeInfo.event._def.extendedProps.EngineerTimeID;

            setAssignedEngineers((prevAssigned) =>
                prevAssigned.map((engineer) =>
                    engineer.id === id
                        ? { ...engineer, start, end } // Update start and end times
                        : engineer
                )
            );


            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}/${month}/${day}`;
            };
            const formatTime = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${hours}:${minutes}:${seconds}`;
            };
            const diffInMs = end.getTime() - start.getTime();
            let diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            diffInDays = parseInt(diffInDays) + 1;
            for (let i = 0; i < diffInDays; i++) {

                const StartData = new Date(start);
                StartData.setDate(StartData.getDate() + i);

                const StartDate = formatDate(new Date(StartData));
                const EndDate = formatDate(new Date(StartData));

                const StartDateTime = formatTime(new Date(start));
                const EndDateTime = formatTime(new Date(end));
                const StartTime = `${StartDate} ${StartDateTime}`;
                const EndTime = `${EndDate} ${EndDateTime}`;
                const { oldEvent } = eventResizeInfo;
                const PreviousStartTime = formatDate(new Date(oldEvent.start));
                const PreviousEndTime = formatDate(new Date(oldEvent.end));
                if (PreviousStartTime === StartDate) {

                    const data = {
                        JobID,
                        UserId,
                        StartTime,
                        EndTime,
                        PreviousStartTime,
                        PreviousEndTime,
                        EngineerTimeID
                    };
                    try {
                        if (id === "" || parseInt(id) === 0) {
                            const message = await handleUpdate(data);
                        }
                    } catch (error) {

                    }
                }
                else {
                    const IssueID = JobID;
                    const UserID = UserId;
                    const startDate = StartTime;
                    const endDate = EndTime;
                    const TotalTime = '1.00';
                    const TotalTravelTime = '0.00';
                    const PayRateID = '1';
                    const postData = {
                        IssueID,
                        UserID,
                        startDate,
                        endDate,
                        TotalTime,
                        TotalTravelTime,
                        PayRateID,
                    };
                    const redirectCallback = () => navigate('/');
                    if (id === "" || parseInt(id) === 0) {
                        const Message = await CreateEngineer(postData, redirectCallback);
                    }

                }
            }
            if (id === "" || parseInt(id) === 0) {
                //  fetchJobEngineers();
            }
        }
        else if (eventType === "task") {
            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            };
            eventResizeInfo.snt_CommunicationType = "2";
            if (eventResizeInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "0") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "2") {

                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }



            return false;
        } else if (eventType === "opportunity") {
            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            };
            eventResizeInfo.snt_CommunicationType = "3";
            if (eventResizeInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "0") {

                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "2") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }
            //  await fetchTask();
            //  await fetchAppointments();
            return false;
        }
    };
    const handleStart = (e, ui) => {
        e.stoppropagation();
    }

    const handleColorChange = async (userID, newColor) => {
        try {
            await UserService.UpdateColor(userID, newColor);
            setUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.UserID === userID ? { ...user, color: newColor } : user
                )
            );
            fetchUsers(selectedTeam);
            fetchJobEngineers();
            // After color change, update the corresponding .fc-h-event class
            updateEventColor(userID, newColor);
        } catch (error) {
            console.error("Failed to update color:", error);
        }
    };

    const updateEventColor = (userID, newColor) => {
        // Assuming that the event has a data attribute or className with userID
        const eventElements = document.querySelectorAll(`.fc-h-event[data-userid="${userID}"]`);
        eventElements.forEach((eventEl) => {
            eventEl.style.backgroundColor = newColor; // Change background color of the event
        });
    };

    const handleEventClick = async (info) => {
        debugger;
        const { eventType } = info.event._def.extendedProps;
        if (eventType != "task" && eventType != "opportunity") {
            if (info.event._def.extendedProps.IssueID) {
                const IssueID = info.event._def.extendedProps.IssueID;
                localStorage.setItem('JobID', IssueID);
                localStorage.setItem('HasRecordUpdated', "0");

                setIsJobModalOpen(true);

            }
            else {
                handleCreateJob();
            }
        }
        else if (eventType === "task") {
            if (info.event._def.extendedProps.IsLead === "1") {
                setLeadID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsOpportunityModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "0") {
                setOpportunityID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsTaskModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "2") {
                setClientCompanyID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                localStorage.setItem('ClientCompanyID', info.event._def.extendedProps.UserID);
                setIsCustomerModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "3") {
                setSupplierID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                localStorage.setItem('SupplierID', info.event._def.extendedProps.UserID);
                setIsSupplierModalOpen(true);
            }

        } else if (eventType === "opportunity") {

            if (info.event._def.extendedProps.IsLead === "1") {
                setLeadID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsOpportunityModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "0") {

                setOpportunityID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsTaskModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "2") {
                setClientCompanyID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                localStorage.setItem('ClientCompanyID', info.event._def.extendedProps.UserID);
                setIsCustomerModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "3") {
                setSupplierID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                localStorage.setItem('SupplierID', info.event._def.extendedProps.UserID);
                setIsSupplierModalOpen(true);
            }
        }


    };
    const formatDate = (dateStr) => {
        // Convert YYYY/MM/DD to YYYY-MM-DD
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };
    const handleCreateJob = () => {
        if (calendarRef.current) {
            setIsSidebarOpen(false);
            const calendarApi = calendarRef.current.getApi();
            const allEvents = calendarApi.getEvents(); // Get all events currently in the calendar

            if (allEvents.filter(event => event.id !== "").length === 0) {
                Swal.fire(
                    Error,
                    "No engineers have been added. Please add at least one engineer.",
                    'error'
                );
                return false;
            }
            else {
                const filteredEvents = allEvents
                    .filter(event => event.id) // Ensure 'id' is not null or undefined
                    .map(event => {

                        debugger;
                        const beginStartDateTime = new Date(`${formatDate(event.start.toISOString().split('T')[0])}T00:00:00`);
                        const endDateTime = new Date(`${formatDate(event.end.toISOString().split('T')[0])}T00:00:00`);
                        const diffInMillisecondss = Math.abs(endDateTime - beginStartDateTime);
                        const diffInHourss = (diffInMillisecondss / (1000 * 60 * 60) / 24) + 1;

                        const startTimeString = `${formatDate('2000/01/01')}T${event.start.toTimeString().split(' ')[0]}`;
                        const endTimeString = `${formatDate('2000/01/01')}T${event.end.toTimeString().split(' ')[0]}`;

                        const startTime = new Date(startTimeString);
                        const endTime = new Date(endTimeString);

                        const differenceInMs = endTime - startTime;

                        // Convert the difference from milliseconds to hours
                        const differenceInHours = differenceInMs / (1000 * 60 * 60);
                        const TotalHourse = diffInHourss * differenceInHours;

                        const HoursDate = TotalHourse.toFixed(2);

                        return {
                            EngineerTimeID: 0,
                            UserID: parseInt(event.id),
                            DisplayName: event.title,
                            DepartBaseDate: "",
                            DepartBaseTime: "",
                            ReturnBaseDate: "",
                            ReturnBaseTime: "",
                            HoursTravel: "0",
                            PayRateID: 'BASC',
                            StartDate: formatDate(event.start.toISOString().split('T')[0]),
                            EndDate: formatDate(event.end.toISOString().split('T')[0]),
                            StartTime: formatDate(event.start.toTimeString().split(' ')[0]),
                            EndTime: formatDate(event.end.toTimeString().split(' ')[0]),
                            Other: "",
                            HoursDate: HoursDate
                        };
                    });

                setTableData(filteredEvents);
                localStorage.setItem('JobID', "0");
                localStorage.setItem('JobCostID', "0");
                localStorage.setItem('HasRecordUpdated', "0");
                setIsJobModalOpen(true);
            }

            // Perform additional actions with filteredEvents, e.g., send to backend
        }
    };
    const handleCloseModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();

        localStorage.setItem('JobID', "0");
        setIsJobModalOpen(false);
    };
    const handleCloseLeadModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();

        setIsTaskModalOpen(false);
        setIsOpportunityModalOpen(false);
        setIsCustomerModalOpen(false);
        setIsSupplierModalOpen(false);

    };
    const handleCloseOpportunityModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();

        setIsOpportunityModalOpen(false);
        setIsTaskModalOpen(false);
        setIsCustomerModalOpen(false);
        setIsSupplierModalOpen(false);
    };
    const handleCloseCustomerModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();

        setIsCustomerModalOpen(false);
        setIsTaskModalOpen(false);
        setIsOpportunityModalOpen(false);
        setIsSupplierModalOpen(false);

    };
    const handleUserChange = (selectedOptions) => {
        setSelectedUsers(selectedOptions || []); // Update selected users
    };
    const userOptions = userList.map(user => ({
        value: user.UserID,
        label: user.DisplayName,
    }));
    const handleUserNameChange = async (selectedValues) => {
        setSelectedUsers(selectedValues);
        // setEventType("Jobs");
        Cookies.set("SelectedUsers", JSON.stringify(selectedValues), { expires: 7 });
        const redirectCallback = () => navigate('/');

        // 🔹 Fetch all data
        const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);
        const taskData = await JobService.TaskForDiaries(redirectCallback);
        const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);

        // 🔹 Filter each based on selectedValues
        const filteredJobs = jobEngineers
            .filter(engineer => selectedValues.includes(String(engineer.UserID)))
            .map(engineer => ({
                title: engineer.IssueTitle,
                start: engineer.StartTime ? new Date(engineer.StartTime.replace("Z", "")) : new Date(),
                end: engineer.EndTime ? new Date(engineer.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID,
                IsLead: "10",
                eventType: "job"
            }));

        const filteredTasks = taskData
            .filter(task => selectedValues.includes(String(task.AssignUserID)))
            .map(task => ({
                title: task.Type,
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));

        const filteredAppointments = appointmentData
            .filter(appointment => selectedValues.includes(String(appointment.AssignUserID)))
            .map(appointment => ({
                title: appointment.Type,
                start: appointment.StartTime ? new Date(appointment.StartTime.replace("Z", "")) : new Date(),
                end: appointment.EndTime ? new Date(appointment.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: appointment.Color,
                description: appointment.vc_Description,
                IssueID: appointment.ID,
                UserID: appointment.LeadID,
                EngineerTimeID: appointment.ID,
                IsLead: appointment.Lead,
                eventType: "opportunity"
            }));
        if (EventType === "All") {
            // Show all events
            setEvents([...filteredJobs, ...filteredTasks, ...filteredAppointments]);
        } else if (EventType === "Jobs") {
            // Show only job events
            setEvents(filteredJobs);
        } else if (EventType === "Tasks") {
            // Show only task events
            setEvents(filteredTasks);
        } else if (EventType === "Appointments") {
            // Show only appointment events
            setEvents(filteredAppointments);
        }
        //setEvents([...filteredJobs, ...filteredTasks, ...filteredAppointments]);
    };

    return (

        <div>
            <Common HelpFormName="Diaries" HelpModule="12" />

            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            {(assignedModules.has(MODULE_IDS.Jobs) &&
                <div className="sidebar-toggle-btn" onClick={toggleSidebar}>
                    {isSidebarOpen ? `Close ${DiariesLabel}` : `Open ${DiariesLabel}`}
                </div>
            )}

            <div className={`right-sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                    <thead style={{ "background": "rgb(77, 138, 192)" }}>
                        <tr>

                            <th>
                                <select name="TeamID" className='form-control' onChange={handleTeamChange}>
                                    {teams.map((team) => (
                                        <option key={team.PK_Team_ID} value={team.PK_Team_ID}>
                                            {team.vc_Name}
                                        </option>
                                    ))}
                                </select>
                            </th>

                        </tr>
                    </thead>
                </table>
                <div className="tab-pane fade show active">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "5px" }}>
                                <div className="divTable">
                                    <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ "width": "10%" }}></th>
                                                <th>Name</th>
                                                <th>Color</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div style={{ maxHeight: "150px", minHeight: "150px", overflow: "auto" }}>
                                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                            <tbody id='external-events'>
                                                {

                                                    users.map((user) => (
                                                        <tr key={user.id}>
                                                            <td>
                                                                <ExternalEvent key={user.id} event={user} />
                                                            </td>
                                                            <td><input
                                                                style={{ width: "25px", height: "20px", border: "none" }}
                                                                type="color"
                                                                value={user.color}  // Use user.Color to set the initial color
                                                                onChange={(e) => handleColorChange(user.id, e.target.value)}
                                                            /></td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                            <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "5px" }}>
                                <div className="divTable">
                                    <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                        <thead>
                                            <tr>
                                                <th>Assigned Engineers</th>

                                            </tr>
                                        </thead>
                                    </table>
                                    <div style={{ maxHeight: "150px", minHeight: "150px", overflow: "auto" }}>
                                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                            <tbody>
                                                {assignedEngineers.length > 0 ? (
                                                    assignedEngineers.map((engineer) => (
                                                        <tr key={engineer.id}>
                                                            <td>{engineer.title}</td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td>
                                                            No Engineers Assigned
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                            <div class='row mb-3' style={{ "marginLeft": "0px", "marginRight": "0px" }}>
                                <label htmlFor="CustomerID" className="col-form-label"><strong> Date: </strong></label>
                                <input
                                    type="date"
                                    id="datepicker"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    className="form-control"
                                />
                            </div>
                            <div class='row mb-3' style={{ "marginLeft": "0px", "marginRight": "0px", "float": "right" }}>

                                <button type="submit" className="btn btn-primary" style={{ "marginLeft": "5px" }} onClick={(event) => handleCreateJob(event)}>
                                    New Job
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content-header">
                <div className="row">
                    <div className="col-xl-3">
                        <h1>Diaries</h1>
                    </div>
                    <div className="col-xl-9" style={{ "textAlign": "right" }}>

                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="table-responsive"></div>

                            <div className="row mb-3">

                                <div className="col-sm-2">
                                    <select className='form-control' id="calendarView" value={calendarView === 'timeGridWeek' && !Weekened ? 'workWeek' : calendarView} onChange={handleViewChange}>
                                        <option value="timeGridWeek">Full Week</option>
                                        <option value="workWeek">Work Week</option> {/* Custom Work Week Option */}
                                        <option value="timeGridDay">Day</option>
                                        <option value="dayGridMonth">Month</option>
                                    </select>
                                </div>

                                <div className="col-sm-2">
                                    <select className='form-control' id="slotDuration" value={slotDuration} onChange={handleSlotDurationChange}>
                                        <option value="00:15:00">15 Minutes</option>
                                        <option value="00:30:00">30 Minutes</option>
                                        <option value="01:00:00">1 Hour</option>
                                    </select>
                                </div>
                                <div className="col-sm-2">
                                    <select className='form-control' id="EventType" value={EventType} onChange={handleEventType}>
                                        <option value="All">All</option>
                                        {(assignedModules.has(MODULE_IDS.Jobs) &&
                                            <option value="Jobs">Jobs</option>
                                        )}
                                        <option value="Tasks">Tasks</option>
                                        <option value="Appointments">Appointments</option>
                                    </select>
                                </div>
                                {(RoleName != "Administratorrr" &&
                                    <div className="col-sm-2">
                                        <MultiSelectDropdown
                                            options={userOptions}
                                            selectedOptions={selectedUsers}
                                            onChange={handleUserNameChange} // Pass handler here
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="calendar-container">

                                <FullCalendar
                                    ref={calendarRef}
                                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                    initialView={calendarView}
                                    view={calendarView}
                                    editable={true}
                                    events={events}
                                    dateClick={handleDateClick}
                                    slotDuration={slotDuration}
                                    slotMinTime={slotMinTime}
                                    slotMaxTime={slotMaxTime}
                                    scrollTime="08:00:00"
                                    slotLabelInterval={slotDuration} // Adjust label interval to match slot duration
                                    key={calendarView}
                                    eventMouseEnter={handleEventRender}
                                    eventDidMount={handleEventRender}
                                    eventDrop={handleEventDrop}
                                    eventReceive={handleEventReceive}
                                    eventResize={handleEventResize}
                                    droppable={true}
                                    eventClick={handleEventClick}
                                    weekends={Weekened}
                                    buttonText={{
                                        today: 'Today'
                                    }}
                                    longPressDelay={1000}
                                    allDaySlot={false}
                                    timeZone="local"
                                />
                                {isJobModalOpen && (
                                    <JobDetailModal JobID={localStorage.getItem('JobID')} onClose={handleCloseModal} onSuccess={fetchJob} CustomerID={0} engineersData={tableData} IsDiaries="1" />
                                )}
                                {isTaskModalOpen && (
                                    <OppurtunityDetailModal OpportunityID={OpportunityID} onClose={handleCloseOpportunityModal} onSuccess={fetchTask} IsDiaries={"1"} CommunicationID={taskID} />
                                )}
                                {isOpportunityModalOpen && (
                                    <LeadDetailModal modalInstance={""} LeadID={LeadID} onClose={handleCloseLeadModal} onSuccess={fetchAppointments} IsDiaries={"1"} CommunicationID={taskID} />
                                )}

                                {isCustomerModalOpen && (
                                    <CreateCustomerModal
                                        ClientCompanyID={ClientCompanyID}
                                        onClose={handleCloseCustomerModal}
                                        onSuccess={fetchTask}
                                        IsDiaries={"1"}
                                        CommunicationID={taskID}
                                    />
                                )}
                                {isSupplierModalOpen && (
                                    <SupplierDetailModal
                                        SupplierID={SupplierID}
                                        onClose={handleCloseCustomerModal}
                                        onSuccess={fetchTask}
                                        IsDiaries={"1"}
                                        CommunicationID={taskID}
                                    />
                                )}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
export default DiariesView;